import HeaderFilter from '../../../components/HeaderFilter';
import { useAuthStore } from '../../../store';
import DeliveryReceiptTable from './DeliveryReceiptTable';
import DeliveryReceiptForm from './DeliveryReceiptForm';
import { DRS_API } from '../../../hooks/useDeliveryReceiptHooks';

/**
 * Delivery receipts -- material sent from MMD to the department that asked for
 * it. Steps 13 and 22 of the sourcing flow.
 */
const DeliveryReceiptPage = () => {
  const moduleName = 'Internal DR';
  const moduleCode = 'DR';

  const { user } = useAuthStore();
  const userModuleAccess = user?.moduleAccess?.find(
    (item) => item.module.code === moduleCode,
  );

  return (
    <div className={'page-wrapper'}>
      <HeaderFilter showCreate={userModuleAccess?.create} />
      <DeliveryReceiptForm api={DRS_API} moduleName={moduleName} />
      <DeliveryReceiptTable
        api={DRS_API}
        moduleName={moduleName}
        moduleCode={moduleCode}
      />
    </div>
  );
};

export default DeliveryReceiptPage;
